/**
 * GOMEZ / FM homepage scripts.
 *
 * Loaded only on the homepage template, deferred, after assets/theme.js.
 * Two small, independent, progressive enhancements. Both are inert if
 * their target markup doesn't exist on the page — nothing here is
 * required for the homepage's content to be visible or usable.
 */

/**
 * Scroll-reveal.
 *
 * HTML contract: any element with `[data-scroll-reveal]`. Adds
 * `is-revealed` once the element enters the viewport (see the
 * reduced-motion-guarded utility in assets/critical.css for the actual
 * fade/transition). When the user prefers reduced motion, every target
 * is revealed immediately and the observer is skipped entirely — not
 * just left to run with a neutralized CSS transition — so content can
 * never end up depending on a scroll interaction to become visible.
 */
(function () {
  'use strict';

  var revealTargets = document.querySelectorAll('[data-scroll-reveal]');
  if (!revealTargets.length) {
    return;
  }

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion || typeof IntersectionObserver === 'undefined') {
    revealTargets.forEach(function (target) {
      target.classList.add('is-revealed');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 }
  );

  revealTargets.forEach(function (target) {
    observer.observe(target);
  });
})();

/**
 * Background-video play/pause toggle.
 *
 * HTML contract: `[data-media-toggle]` inside a
 * `.section-media__video-wrapper` (see snippets/section-media.liquid),
 * containing two pre-rendered label spans —
 * `[data-media-toggle-pause]` and `[data-media-toggle-play]` — this
 * only toggles which one has the `hidden` attribute; it never needs to
 * know the translated label text itself.
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-media-toggle]').forEach(function (button) {
    var wrapper = button.closest('.section-media__video-wrapper');
    var video = wrapper && wrapper.querySelector('.section-media__video');
    var pauseLabel = button.querySelector('[data-media-toggle-pause]');
    var playLabel = button.querySelector('[data-media-toggle-play]');
    if (!video) {
      return;
    }

    button.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        button.setAttribute('aria-pressed', 'false');
        if (pauseLabel) pauseLabel.hidden = false;
        if (playLabel) playLabel.hidden = true;
      } else {
        video.pause();
        button.setAttribute('aria-pressed', 'true');
        if (pauseLabel) pauseLabel.hidden = true;
        if (playLabel) playLabel.hidden = false;
      }
    });
  });
})();
